// extracted by mini-css-extract-plugin
module.exports = {"special-buy-categories":"special-buy-categories--kmktk"};